<script>
export default {
  name: 'ModalVeiculoSemFipeEndosso',
  props: ['veiculoSemValorFipe', 'popupVeiculoSemFipeValor'],
  data() {
    return {
      veiculoSemFipe: [],
      popupVeiculoSemFipe: false,
      tituloModal: 'Veículo sem Fipe',
    };
  },
  watch: {
    popupVeiculoSemFipeValor(newValue) {
      this.popupVeiculoSemFipe = newValue;
    },
    veiculoSemValorFipe(newValue) {
      this.veiculoSemFipe = newValue;
    },
  },
  methods: {
    closeModal() {
      this.$emit('closeModal');
    },
  },
};
</script>

<template>
  <vs-popup
    :title="tituloModal"
    :active.sync="popupVeiculoSemFipe"
    @close="closeModal()"
  >
    <vs-card>
      <div v-for="(veiculo, index) in veiculoSemFipe" :key="index">
        <div
          class="flex justify-between px-3 py-2 border border-solid d-theme-border-grey-light rounded my-2 align-center"
        >
          <div>
            <p class="text-sm font-bold">
              Código do Associado: {{ veiculo['Cod Segurado'] }}
            </p>
            <p class="text-sm font-bold">
              Placa / Chassi: {{ veiculo.placa || veiculo.chassi }}
            </p>
          </div>
          <router-link
            target="_blank"
            :to="`/DetalheAssociado/${veiculo['Cod Segurado']}`"
          >
            <vs-button
              @click="closeModal()"
              color="success"
              type="gradient"
              radius
              class="h-10 w-10"
              ><vs-icon icon="edit"></vs-icon>
            </vs-button>
          </router-link>
        </div>
      </div>
    </vs-card>
  </vs-popup>
</template>

<style scoped></style>
